// extracted by mini-css-extract-plugin
export var container = "_s2-0";
export var table = "_s2-2";
export var tableWrapper = "_s2-1";